import React, { useState } from "react";
import {
  Box,
  Checkbox,
  FormControl,
  TextField,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Table from "react-bootstrap/Table";

const CohortVMSelect = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const selectedVMs = props.cohortSelectVM || [];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const filteredVMs =
    props.seedData.machines?.filter(
      (vm) =>
        vm.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        vm.id.toString().includes(searchTerm)
    ) || [];

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleCheckboxChange = (e, id) => {
    const updated = e.target.checked
      ? [...selectedVMs, id]
      : selectedVMs.filter((vmId) => vmId !== id);
    props.handleCohortSelectVMChange(updated);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.wrapper}>
        <FormControl component="fieldset" fullWidth>
          <Box component="p" sx={styles.label}>
            Select Vending Machine <Box component="span" sx={styles.required}>*</Box>
          </Box>
          <TextField
            fullWidth
            variant="standard"
            label="Search by VM ID/Name"
            value={searchTerm}
            onChange={handleSearchChange}
            sx={styles.textField}
            size={isMobile ? "small" : "medium"}
          />
          <TableContainer 
            component={Paper} 
            sx={styles.tableContainer}
          >
            <Box sx={styles.tableWrapper}>
              <Table stickyHeader>
                <TableBody>
                  {filteredVMs.map((vm, index) => (
                    <TableRow
                      key={vm.id}
                      hover
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                        cursor: "pointer",
                      }}
                    >
                      <TableCell sx={{ width: "60px" }}>
                        <Checkbox
                          checked={selectedVMs.includes(vm.id)}
                          onChange={(e) => handleCheckboxChange(e, vm.id)}
                          sx={styles.checkbox}
                          size={isMobile ? "small" : "medium"}
                        />
                      </TableCell>
                      <TableCell sx={{ minWidth: isMobile ? "80px" : "120px" }}>
                        {vm.id}
                      </TableCell>
                      <TableCell sx={{ minWidth: isMobile ? "150px" : "200px" }}>
                        {vm.name || "N/A"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </TableContainer>
          {props.errors?.cohortSelectVM && (
            <Box component="p" sx={styles.error}>
              {props.errors.cohortSelectVM}
            </Box>
          )}
        </FormControl>
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: { xs: "20px 10px", sm: "30px 20px", md: "40px" },
    borderRadius: "24px",
    boxSizing: "border-box",
  },
  wrapper: {
    width: "100%",
    maxWidth: { xs: "100%", sm: "90%", md: "80%", lg: "70%" },
  },
  label: {
    fontSize: { xs: "18px", sm: "20px", md: "24px" },
    fontWeight: 500,
    marginBottom: { xs: "8px", sm: "12px" },
  },
  required: {
    color: "red",
  },
  textField: {
    "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
    "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
    marginBottom: { xs: "10px", sm: "15px" },
  },
  tableContainer: {
    maxHeight: { xs: "50vh", sm: "60vh" },
    marginTop: { xs: "10px", sm: "15px" },
    overflowX: "auto",
  },
  tableWrapper: {
    width: "100%",
    minWidth: { xs: "300px", sm: "100%" },
    overflowX: "auto",
  },
  checkbox: {
    color: "#14AE78",
  },
  error: {
    color: "red",
    fontSize: { xs: "12px", sm: "14px" },
    marginTop: { xs: "8px", sm: "10px" },
  },
};

export default CohortVMSelect;